import { render, staticRenderFns } from "./videoPlayerComponent.vue?vue&type=template&id=6ff0ab19&"
import script from "./videoPlayerComponent.vue?vue&type=script&lang=ts&"
export * from "./videoPlayerComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports